module.exports = __webpack_public_path__ + "fonts/fa-regular-400.bd52a727.woff2";